module.exports = __webpack_public_path__ + "static/media/3-passos.c728c9c8.webm";